import {PLAYER_BONUS_TYPES} from '../../configs/playerBonus';
import {PLAYER_COLOR_INITIAL_NAME_MAPPING} from '../../configs/players';
import {BOT_NAMES} from '../../constants/botNames';
import {getRandomElement} from '../other/getRandomElement';
import {
  NEWBIE_BATTLE_BOT_FACTION_IDS,
  NEWBIE_BATTLE_PLAYER_FACTION_ID,
} from '../../configs/newbieBattle';

/**
 * Состав первого боя новичка против ботов (см. configs/newbieBattle):
 * живой игрок первым цветом поля за орков, дальше боты за Вентори и Гномов
 * без бонусов.
 *
 * Формат тот же, что собирает экран настройки локальной партии
 * (HotSeatPlayersInitPage): цвета берутся из самого поля, а фракции здесь
 * заданы заранее — настраивать новичку нечего. Имена ботам даются из общего
 * списка, как в обычной локальной партии; на поле их не должно быть
 * одинаковых.
 *
 * Лишние цвета поля (если поле окажется больше, чем на трех игроков) в состав
 * не берем: соперников ровно столько, сколько фракций в конфиге.
 *
 * @param {string[]} playerColors - цвета поля по порядку (из его json)
 * @param {Object} [params]
 * @param {string} [params.playerName] - имя живого игрока из профиля
 * @param {Function} [params.pickBotName] - выбор имени бота (для тестов)
 * @returns {Array<Object>} игроки для App.handleHotSeatPlayersSubmit
 */
export const buildNewbieBattlePlayers = (playerColors, {playerName, pickBotName} = {}) => {
  const colors = (playerColors || []).slice(0, NEWBIE_BATTLE_BOT_FACTION_IDS.length + 1);
  if (colors.length < NEWBIE_BATTLE_BOT_FACTION_IDS.length + 1) {
    return [];
  }

  const usedNames = new Set();
  const takeBotName = (color) => {
    const freeNames = BOT_NAMES.filter((name) => !usedNames.has(name));
    const name = (pickBotName || getRandomElement)(freeNames)
      || `Бот ${PLAYER_COLOR_INITIAL_NAME_MAPPING[color]}`;
    usedNames.add(name);
    return name;
  };

  return colors.map((color, index) => (index === 0
    ? {
      color,
      name: playerName || PLAYER_COLOR_INITIAL_NAME_MAPPING[color],
      isBot: false,
      factionId: NEWBIE_BATTLE_PLAYER_FACTION_ID,
      bonus: PLAYER_BONUS_TYPES.NONE,
    }
    : {
      color,
      name: takeBotName(color),
      isBot: true,
      factionId: NEWBIE_BATTLE_BOT_FACTION_IDS[index - 1],
      bonus: PLAYER_BONUS_TYPES.NONE,
    }));
};
